<template>
  <modalForm :title="$t('customers.add')" :submit-label="$t('actions.add')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-1">{{ error }}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('customers.name') }}:</p>
      <input type="text" name="name" v-model="name" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.name.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('customers.phone') }}:</p>
      <vue-tel-input v-on:input="phoneInputEvent" v-model="phoneNumber" class="focus:ring-indigo-500 focus:border-indigo-500 border p-1 rounded-md shadow-sm sm:text-sm" :class="{'phone-invalid': !phoneNumberValid || v$.phoneNumber.$errors.length > 0, 'phone-valid': phoneNumberValid && v$.phoneNumber.$errors.length === 0}"></vue-tel-input>
      <div v-for="error of v$.phoneNumber.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('customers.email') }}:</p>
      <input type="email" name="email" v-model="email" class="focus:ring-indigo-500 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm ">
      <div v-for="error of v$.email.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('customers.comments') }}:</p>
      <textarea type="text" v-model="comments" class="focus:ring-indigo-500 h-24 focus:border-indigo-500 block border border-gray-300 p-2 w-full rounded-md shadow-sm sm:text-sm "></textarea>
      <div v-for="error of v$.comments.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import modalForm from '../building_blocks/modalForm'
import formViewMixin from '../building_blocks/formViewMixin'
import customerModel from '@/models/customer'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { useCustomerStore } from '@/stores/customers';


export default {
  mixins: [formViewMixin],
  name: 'CustomerAdd',
  setup () {
    let customerStore = useCustomerStore();
    return { v$: useVuelidate(), customerStore }
  },
  components: {
    modalForm,
  },
  methods: {
    async onFormValid() {
      let response;
      let customerData = customerModel.buildCreate(this.name, this.phoneNumber, this.avatar, this.email, this.comments);
      try {
        response = await customerModel.createCustomer(customerData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('customers.errorCreating');
      }
      if (response && response.status === 201) {
        this.error = '';
        this.$emit('create-finished-event');
      }
    },
    cancel() {
      this.$emit('create-finished-event');
    },
    phoneInputEvent(value, valueObject) {
      if (valueObject) {
        if (value) {
          this.phoneNumber = `${valueObject.countryCallingCode}${valueObject.nationalNumber}`;
        } else {
          this.phoneNumber = '';
        }
        if (valueObject.valid) {
          this.phoneNumberValid = true;
        } else {
          this.phoneNumberValid = !value;
        }
      }
    },
  },
  data() {
    return {
      'name': '',
      'phoneNumber': '',
      'phoneNumberValid': true,
      'avatar': '',
      'email': '',
      'comments': '',
      'error': '',
    }
  },
  validations () {
    const phoneValid = (value) => {
      if (value) {
        return isValidPhoneNumber(`+${value}`);
      }
      return true;
    }
    const phoneUnique = (value) => {
      return this.customerStore.getCountByPhoneNumber(value) === 0;
    }
    return {
      'name': { required },
      'phoneNumber': { phoneValid, phoneUnique: helpers.withMessage(this.$t('customers.phoneExists'), phoneUnique) },
      'email': { email },
      'avatar': {},
      'comments': {},
    }
  }
}
</script>
